import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import BaseLayer from '../core/BaseLayer';
import PointModels from './models/index';

var PointLayer = function (_BaseLayer) {
  _inherits(PointLayer, _BaseLayer);

  var _super = _createSuper(PointLayer);

  function PointLayer() {
    var _this;

    _classCallCheck(this, PointLayer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "type", 'PointLayer');

    return _this;
  }

  _createClass(PointLayer, [{
    key: "buildModels",
    value: function buildModels() {
      var modelType = this.getModelType();
      this.layerModel = new PointModels[modelType](this);
      this.models = this.layerModel.initModels();
    }
  }, {
    key: "rebuildModels",
    value: function rebuildModels() {
      this.models = this.layerModel.buildModels();
    }
  }, {
    key: "getModelTypeWillEmptyData",
    value: function getModelTypeWillEmptyData() {
      if (this.shapeOption) {
        var _this$shapeOption = this.shapeOption,
            field = _this$shapeOption.field,
            values = _this$shapeOption.values;

        var _this$getLayerConfig = this.getLayerConfig(),
            shape2d = _this$getLayerConfig.shape2d,
            shape3d = _this$getLayerConfig.shape3d;

        var iconMap = this.iconService.getIconMap();

        if (field && (shape2d === null || shape2d === void 0 ? void 0 : shape2d.indexOf(field)) !== -1) {
          return 'fill';
        }

        if (values && values instanceof Array) {
          var _iterator = _createForOfIteratorHelper(values),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var v = _step.value;

              if (typeof v === 'string' && iconMap.hasOwnProperty(v)) {
                return 'image';
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }

      return 'normal';
    }
  }, {
    key: "getConfigSchema",
    value: function getConfigSchema() {
      return {
        properties: {
          opacity: {
            type: 'number',
            minimum: 0,
            maximum: 1
          }
        }
      };
    }
  }, {
    key: "getDefaultConfig",
    value: function getDefaultConfig() {
      var type = this.getModelType();
      var defaultConfig = {
        fillImage: {},
        normal: {
          blend: 'additive'
        },
        radar: {},
        simplePoint: {},
        fill: {
          blend: 'normal'
        },
        extrude: {},
        image: {},
        icon: {},
        text: {
          blend: 'normal'
        },
        vectorpoint: {},
        tile: {},
        earthFill: {},
        earthExtrude: {}
      };
      return defaultConfig[type];
    }
  }, {
    key: "getModelType",
    value: function getModelType() {
      var PointTypes = ['fillImage', 'fill', 'radar', 'image', 'normal', 'simplePoint', 'extrude', 'text', 'icon', 'vectorpoint', 'tile', 'earthFill', 'earthExtrude'];

      if (this.layerSource.parser.type === 'mvt') {
        return 'vectorpoint';
      }

      if (this.layerType && PointTypes.includes(this.layerType)) {
        return this.layerType;
      }

      var layerData = this.getEncodedData();

      var _this$getLayerConfig2 = this.getLayerConfig(),
          shape2d = _this$getLayerConfig2.shape2d,
          shape3d = _this$getLayerConfig2.shape3d;

      var iconMap = this.iconService.getIconMap();
      var item = layerData.find(function (fe) {
        return fe.hasOwnProperty('shape');
      });

      if (!item) {
        return this.getModelTypeWillEmptyData();
      } else {
        var shape = item.shape;

        if (shape === 'dot') {
          return 'normal';
        }

        if (shape === 'simple') {
          return 'simplePoint';
        }

        if (shape === 'radar') {
          return 'radar';
        }

        if (shape === 'fillImage') {
          return 'fillImage';
        }

        if ((shape2d === null || shape2d === void 0 ? void 0 : shape2d.indexOf(shape)) !== -1) {
          return 'fill';
        }

        if ((shape3d === null || shape3d === void 0 ? void 0 : shape3d.indexOf(shape)) !== -1) {
          return 'extrude';
        }

        if (iconMap.hasOwnProperty(shape)) {
          return 'image';
        }

        if (this.fontService.getGlyph(shape) !== '') {
          return 'icon';
        }

        return 'text';
      }
    }
  }]);

  return PointLayer;
}(BaseLayer);

export { PointLayer as default };
//# sourceMappingURL=index.js.map